package dairy.mynotes

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import dairy.mynotes.navigation.AppNavigation

@Composable
fun App() {
    MaterialTheme {
        AppNavigation()
    }
}